// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Section-module--cls1--3EWvS","cls2":"styles-Section-module--cls2--2iNnF styles-Section-module--cls1--3EWvS"};